import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Cell,
  ResponsiveContainer,
  Tooltip,
  LabelList,
} from "recharts";
import { scoreColor } from "../../lib/operatorWalk";

const axisFont = { fontFamily: "'Outfit', sans-serif", fontSize: 12, fill: "#64748B" };

export default function CategoryBars({ categories }) {
  const data = categories.map((c) => ({
    name: c.title,
    pct: c.percentage,
    score: c.total,
    max: c.max,
  }));

  return (
    <div className="w-full" data-testid="category-bars" style={{ height: Math.max(220, data.length * 54) }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 4, right: 44, bottom: 4, left: 8 }}
          barCategoryGap={14}
        >
          <XAxis type="number" domain={[0, 100]} hide />
          <YAxis
            type="category"
            dataKey="name"
            width={130}
            tick={axisFont}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip
            cursor={{ fill: "rgba(191,167,255,0.12)" }}
            formatter={(v, n, p) => [`${p.payload.score}/${p.payload.max} (${v}%)`, "Score"]}
            contentStyle={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, border: "1px solid #E5D4FF" }}
          />
          <Bar dataKey="pct" radius={[0, 0, 0, 0]} isAnimationActive>
            {data.map((d, i) => (
              <Cell key={i} fill={scoreColor(d.pct)} />
            ))}
            <LabelList
              dataKey="score"
              position="right"
              formatter={(v) => `${v}`}
              style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 16, fill: "#3B1E5A", fontWeight: 600 }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
